import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "./Services.css";
import { getStoredData } from '../../JsonFiles/fetchData';

// Importing components
import IntroTemplate from "../../components/IntroTemplate/IntroTemplate";
import HomeBlog from '../../components/HomeBlog/HomeBlog';
import ActivitiesCard from '../../components/ActivitiesCard/ActivitiesCard.js';
import RedirectToPage from "../../components/RedirectToPage/RedirectToPage";
import SmallDescription from "../../components/SmallDescription/SmallDescription";

const Services = () => {
  const data = getStoredData()?.["5"] ?? {};
  const [News, setNews] = useState([]);
  const [Services, setServices] = useState([]);

  useEffect(() => {
    axios
      .get('https://shahbad-enterprises-backend.vercel.app/services')
      .then((response) => setServices(response.data))
      .catch((error) => console.error('Error fetching services:', error));

    axios
      .get('https://shahbad-enterprises-backend.vercel.app/news')
      .then((response) => setNews(response.data))
      .catch((error) => console.error('Error fetching news:', error));
  }, []);

  return (
    <div className="services-container">
      <IntroTemplate logo={data.logo} title={data.title} image={data.image} />
      <SmallDescription title={data.smallTitle} details={data.SmallDetails}/>
      <ActivitiesCard data={Services} /> {/* Pass Services data here */}
      <HomeBlog
        title={data.HomeBlogTitle}
        link={data.HomeBlogLink}
        text={data.HomeBlogText}
        blogs={News}
      />
      <RedirectToPage 
        link={data.RedirectLink} 
        title={data.RedirectTitle} 
        image={data.RedirectImage} 
        details={data.RedirectDetails} 
        ButtonText={data.RedirectButtonText}
      />
    </div>
  );
};

export default Services;
